export const baseStyles = {
    menu: (base: any) => ({
      ...base,
      zIndex: 9999, // Ensures the menu is on top of all other elements
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 9999, // Ensures the portal has a high z-index
    }),
  };

export const darkThemeStyles = {
    control: (provided: any) => ({
      ...provided,
      backgroundColor: "#333",
      borderColor: "#555",
    }),
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: "#333",
      color: "white",
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#444" : "#333",
      color: state.isDisabled ? "#777" : "white",
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: "white",
    }),
  };